export default __webpack_public_path__ + "static/media/client50.68242cb2.png";